/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-spaces-and-tabs */
import PropTypes from 'prop-types';
import clsx from 'clsx';

import Phone from '../../../images/map-phone.inline.svg';
import Clock from '../../../images/clock.inline.svg';
import Pin from '../../../images/pin.inline.svg';

const InfoWindow = ({ place }) => {
	const {
		name,
		street,
		city,
		state,
		country,
		postal,
		phone1,
		time,
		description,
		url,
		show,
	} = place || {};

	const times =
		time &&
		Object.entries(time).map(([key, value], index) => {
			const day =
				index === 1 || index === 3
					? key.substr(0, 4).toProperCase()
					: key.substr(0, 3).toProperCase();

			if (value[0]) {
				const twoShifts = value[0] && value[1];
				const morningShift = `${value[0]?.from?.hour}:${
					value[0]?.from?.min == 0 ? '00' : value[0]?.from?.min
				} AM - ${value[0]?.to?.hour}:${
					value[0]?.from?.min == 0 ? '00' : value[0]?.from?.min
				} AM`;
				const afternoonShift = `${value[1]?.from?.hour}:${
					value[1]?.from?.min == 0 ? '00' : value[1]?.from?.min
				} PM - ${value[1]?.to?.hour - 12}:${
					value[1]?.from?.min == 0 ? '00' : value[1]?.from?.min
				} PM`;

				const continuousShift = `${value[0]?.from?.hour}:${
					value[0]?.from?.min == 0 ? '00' : value[0]?.from?.min
				} AM - ${value[0]?.to?.hour - 12}:${
					value[0]?.from?.min == 0 ? '00' : value[0]?.from?.min
				} PM`;

				return twoShifts
					? `${day}: ${morningShift} ${afternoonShift}`
					: `${day}: ${continuousShift}`;
			} else {
				return day;
			}

			// multiple for some reason?
			//return value && value.map(val => `${key.toProperCase()}: ${val.from.hour}:00 AM - ${val.to.hour}:00 PM`);
		});

	return (
		<section
			className={clsx('location-search__window', show === true && 'is-active')}
		>
			{place !== null && (
				<>
					<div className="location-search__window-details">
						<h2 className="location-search__window-title">{name}</h2>
						<div className="location-search__window-block">
							<h3 className="location-search__window-heading">
								<Pin /> Address:
							</h3>
							<p className="location-search__window-copy">
								{street}
								<br />
								{city}, {state} {postal}
							</p>
						</div>
						{phone1 !== '' && (
							<div className="location-search__window-block">
								<h3 className="location-search__window-heading">
									<Phone /> Phone:
								</h3>
								<p className="location-search__window-copy">{phone1}</p>
							</div>
						)}
						<div className="location-search__window-block">
							<h3 className="location-search__window-heading">
								<Clock /> Hours:
							</h3>
							<div className="location-search__window-hours">
								{times &&
									times.map((time, index) => (
										<p
											key={index}
											className="location-search__window-copy location-search__window-copy--hours"
										>
											{!time.includes(':') ? (
												<>
													{time}:{' '}
													<span className="typography typography--error location-search__window-copy--closed">
														{' '}
														Closed
													</span>
												</>
											) : (
												time
											)}
										</p>
									))}
							</div>
						</div>
						<div
							className="location-search__window-copy"
							dangerouslySetInnerHTML={{ __html: description }}
						/>
					</div>
					<div className="location-search__btns">
						<a
							className="btn btn--secondary"
							target="_blank"
							rel="noreferrer"
							href={`${process.env.GATSBY_MAGENTO_PROD_BASE}/${url}`}
						>
							Book Test at this Location
						</a>
						{/* <button className="btn btn--outlined">More Info</button> */}
					</div>
				</>
			)}
		</section>
	);
};

InfoWindow.propTypes = {
	place: PropTypes.shape({
		name: PropTypes.string,
		street: PropTypes.string,
		city: PropTypes.string,
		postal: PropTypes.string,
		state: PropTypes.string,
		country: PropTypes.string,
		description: PropTypes.string,
		url: PropTypes.string,
		phone1: PropTypes.string,
		time: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		show: PropTypes.bool,
	}),
};

export default InfoWindow;
